import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'
import qs from 'qs'

import { schema as taskSchema } from './task'

export { collection } from './task'

export const schema = new schemas.Array(taskSchema)

type FetchParamsType = { offset: number; pagesize: number }

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  (
    { caseId }: { caseId: string },
    _: unknown,
    { offset, pagesize }: FetchParamsType
  ) => {
    const requestParams = qs.stringify({ offset, pagesize })
    return callApi(`${apiBase}/cases/${caseId}/tasks?${requestParams}`, schema)
  }
